export const PATHS = {
  HOME: '/', //done
  CONTACT: '/contact-us/', //done not links found
  REQUEST_A_DEMO: '/request-a-demo/', //done not links found
  DEMOHOME: '/demohome/', // done not links found
  PRICING: '/pricing/', // done
  COWBOY: '/cowboy/', // done not links found
  LAUNCH: '/launch/', // done not links found
  VIDEO_SCENARIOS: '/video-scenarios/', // done 
  VIDEO: '/video/', // done
  COVID_SUPPORT: '/covid-support/',  // done not links found
  DEMO: '/demo/', // done not links found
  INDEX_OLD: '/index-old/', // done not links found
  PRICING_V2: '/pricing-v2/', // done not links found


  //Company
  ABOUT: '/company/about/', // done
  JOBS: '/company/jobs/', // done not links found 
  INVESTORS: '/company/investors/', // done
  PRESS: '/company/press/', // done
  MEDIA: '/company/media/', // done

  //Legal
  PRIVACY_POLICY: '/legal/privacy-policy/', // done
  
  //Resources 
  RESOURCES: '/resources', // done
  CUSTOMER_STORIES: '/resources/customer-stories', // done
  REMY_STORY: '/resources/customer-stories/remy-cointreau/', // done
  EVEN_STORY: '/resources/customer-stories/even-financial/', // done
  INVISION_STORY: '/resources/customer-stories/invision/', // done
  SHOWBIE_STORY: '/resources/customer-stories/showbie/', // done
  CHARTING_BETTER_WORKPLACES_2020: '/resources/guides-ebooks/charting-better-workplaces/2020/', // done
  FAIR_EQUITABLE_COMPENSATION: '/resources/guides-ebooks/fair-equitable-compensation/', // done
  RETURN_TO_WORK: '/resources/guides-ebooks/return-to-work/', // done
  REMOTE_WORK_SALARIES: '/resources/guides-ebooks/remote-work-salaries/', // done
  PLANNING_FOR_2021: '/resources/webinars/planning-for-2021/', // done
  DEI_REPORTING: '/resources/guides-ebooks/dei-reporting/',
  CHARTING_BETTER_GALAXIES: '/resources/guides-ebooks/charting-better-galaxies/',

  //Product
  OVERVIEW: '/product/overview/', // done
  WHY_CHARTHOP: '/product/why-charthop/', // done
  DEI: '/product/dei/', // done
  INTEGRATIONS: '/product/integrations/', // done
  BAMBOOHR: '/product/integrations/bamboohr/', // done
  SAPLING: '/product/integrations/sapling/', // done
  WORKDAY: '/product/integrations/workday/', // done
  SAP_SUCCESSFACTORS: '/product/integrations/sap-successfactors/', // done
  WORKLIFE: '/product/integrations/worklife/', // done not links found
  GUSTO: '/product/integrations/gusto', // done
  JUSTWORKS: '/product/integrations/justworks/', // done
  ADP: '/product/integrations/adp/', // done not links found
  NAMELY: '/product/integrations/namely/', // done
  SEQUOIA: '/product/integrations/sequoia/', // done
  TRINET: '/product/integrations/trinet/', // done
  TWIST: '/product/integrations/twist/', // done no links found
  RIPPLING: '/product/integrations/rippling/', // done
  ZENEFITS: '/product/integrations/zenefits/', // done
  PAYLOCITY: '/product/integrations/paylocity/', // done
  GREENHOUSE: '/product/integrations/greenhouse/', // done no links found
  SHRM: '/product/integrations/shrm/', // done no links found
  ULTIPRO: '/product/integrations/ultipro/', // done no links found
  HUMAANS: '/product/integrations/humaans/', // done
  CONNECT: '/product/connect/', // done
  SECURITY: '/product/security/', // done
  ORG_CHART: '/product/org-chart/', // done
  PEOPLE_ANALYTICS: '/product/people-analytics/', // done
  PLANNING: '/product/planning/', // done
  COMPENSATION: '/product/compensation/', // done
  PERFORMANCE: '/product/performance/', // done


  //Blog
  BLOG: '/blog/', // done
  BLOG_BEST_PRACTICES: '/blog/best-practices/', // done no links found
  BLOG_COMPANY_UPDATES: '/blog/company-updates/', // done no links found
  BLOG_PRODUCT_UPDATES: '/blog/product-updates/', // done no links found
  BLOG_DEI: '/blog/dei/', // done no links found
  BLOG_ORG_CHART: '/blog/org-chart/', // done no links found
}
